<template>
    <v-container fluid>
    <field-form v-if="item && campaign && productCategories" @save="save" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" :last-editable-step="lastEditableStep" :allow-editable="true" @cancel="cancelWizard()" @click-step="changeStep">
        <!--
        <v-row>
        <v-col cols="12" md="6">
        <v-tabs>
            <v-tab 
                v-for="(t,i) in variants"
                :key="`contentVariant${i}`"
                :to="{name: 'campaign-design-email-variant', params: { variant: t.id } }">
                
                <v-icon left :color="t.color">{{ t.icon }}</v-icon>
                <span>{{ t.name }}</span>
                
                
                </v-tab>
            <action-button  icon="$add" @click="addVariant" :loading="creating" />
        </v-tabs>
                </v-col>
        <v-col cols="12" md="6">
            <v-toolbar
                xdense
            >
            
            <v-text-field
                hide-details
                prepend-icon="$subject"
                single-line
                v-model="fields.subject"
                dense
            ></v-text-field>
            <v-text-field
                :label="$t('campaigns.design.variants.subject')"
                prepend-icon="$subject"
                dense
                single-line
                hide-details
                v-model="fields.subject"
            ></v-text-field>
            <v-switch :label="$t('campaigns.design.variants.active')" v-model="fields.active" />
            </v-toolbar>
        </v-col>
        </v-row>
        -->
        <v-toolbar dense class="mb-1">
            <v-toolbar-title style="overflow:visible" class="mr-1">{{ $t('campaigns.design.variants.title') }}</v-toolbar-title>
            <v-tabs>
            <v-tab 
                v-for="(t,i) in variants"
                :key="`contentVariant${i}`"
                :to="{name: 'campaign-design-email-variant', params: { variant: t.id } }">
                <!--
                <v-icon left :color="t.color">{{ t.icon }}</v-icon>
                <span>{{ t.name }}</span>
                -->
                <v-icon :color="t.color">{{ t.icon }}</v-icon>
                </v-tab>
            <action-button :disabled="variants.length >= 26" icon="$add" :tooltip="$t('campaigns.design.variants.add')" @click="addVariant" :loading="creating" />
        </v-tabs>
            <v-divider vertical class="mr-3"/>
            <v-text-field
                :label="$t('campaigns.design.variants.subject')"
                style="width:600px"
                prepend-icon="$subject"
                single-line
                hide-details
                v-model="fields.subject"
            ></v-text-field>
            <v-switch hide-details :label="$t('campaigns.design.variants.active')" v-model="fields.active" />
        </v-toolbar>

        <template v-if="!fields.templateUnlayer">
            <template-selector :key="item.id" @select="selectTemplate" variants :campaign="campaign.id"/>
        </template>
        <template v-else>
            <newsletter-editor class="mb-3" ref="editor" :key="item.id"
                :height="height" 
                :campaign="campaign.id" 
                :newsletter="fields.templateUnlayer" 
                :html.sync="htmltemplate"
                :text.sync="texttemplate" 
                :valid.sync="valid" 
                :specs.sync="fields.templateSpecs"
                :specsNew.sync="fields.templateSpecsNew"
                :specsCategories.sync="fields.templateSpecsCategories" 
                :unsubscribe.sync="unsubscribe"
                :dnsName="campaign.domain.dnsName"
                :productCategories="productCategories"
                @save="updateTemplate"
            />
        </template>
    
    
    
    <confirm-dialog title="dialog.unsaved.title" button-caption="dialog.leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          {{ $t('dialog.unsaved.text') }}
    </confirm-dialog>
    </field-form>
    
        <v-card v-else class="mb-3">
        <v-card-text>
        <v-row>
            <v-col cols="9">
                <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="i in [0,1,2,3,4,5,6,7,8,9,10,11]" :key="i">
                    <v-skeleton-loader type="image"/>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="3">
                <v-skeleton-loader type="list-item-avatar@3" class="mb-1"/>
                <v-skeleton-loader type="actions" class="mb-1"/>
                <v-skeleton-loader type="list-item-avatar@3" class="mb-1"/>
                <v-skeleton-loader type="actions" class="mb-1"/>
            </v-col>
        </v-row>
        </v-card-text>
        </v-card>
    </v-container>
</template>
<script>

import { mapState } from "vuex";
import {mixin as VueTimers} from 'vue-timers'

import NewsletterEditor from '@/components/NewsletterEditor'
import TemplateSelector from "@/components/TemplateSelector"
import EntityForm from '@/mixins/entity-form'
import ConfirmLeave from '@/mixins/confirm-leave'
import Wizards from "@/mixins/wizards"
import Formatters from "@/mixins/formatters"

export default {
    name: 'Design',
    components: {
        NewsletterEditor,
        TemplateSelector
    },
    mixins: [ ConfirmLeave, EntityForm, Wizards, Formatters, VueTimers ],
    data() {
        return {
            endpoint: 'variants',
            fields: {
                templateSpecs: null,
                templateSpecsNew: null,
                templateSpecsCategories: null,
                templateUnlayer: null,
                templateSES: null,
                subject: null,
                active: null
            },
            valid: true,
            htmltemplate: null,
            texttemplate: null,
            sestemplate: null,
            unsubscribe: true,
            creating: false,
        }
    },
    computed: {
        wizardParams() {
            let p = {
            };
            if(this.item) {
                p.medium = this.item.medium?.toLowerCase() || 'email';
            }
            return p;
        },
        height() {
            return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) - 240 - 10;
        },
        variants() {
            return this.campaign?.variants.map(v => ({ id: v.id, name: this.$t('campaigns.design.variants.name', {name: v.name}), ...this.getVariantIcon(v) }))
        },
        ...mapState('domains', { productCategories: 'productCategories', domain: 'item' }),
        ...mapState('campaigns', { campaign: 'item' }),
    },
    watch: {
        item() {
            this.detectCampaignVariants();
        },
        campaign() {
            this.loadCategories();
            this.detectCampaignVariants();
        },
        htmltemplate() {
            this.getSESTemplate();
        },
        texttemplate() {
            this.getSESTemplate();
        }
    },
    methods: {
        getVariantIcon(v) {
            /*
                [
                    { icon: '$ok', color: 'success', name: 'Varianta A'},
                    { icon: '$warn', color: 'warning', name: 'Varianta B'},
                    { icon: '$close', color: 'grey', name: 'Varianta C'},
                    { icon: '$ok', color: 'success', name: 'Varianta D'}
                ]
                */
            let icon = `$campaignVariant${v.name}`;
            if(!v.active) {
                return { icon/*: '$close'*/, color: 'grey'};
            }
            if(!v.subject || v.subject.trim().length == 0) {
                // this will never happen as you cant save (and activate) variant without a subject
                return { icon/*: '$warn'*/, color: 'warning'};
            }
            return { icon/*: '$ok'*/, color: 'success' }
        },
        selectTemplate(data) {
            this.fields.templateUnlayer = data;
        },
        loadCategories() {
            if(this.campaign && !this.productCategories) {
                console.debug('Component loading product categories...');
                this.$store.dispatch('domains/getProductCategories', { domainId: this.campaign.domainID });
            }
        },
        updateTemplate(data) {
            //console.debug('Updating template...');
            this.fields.templateUnlayer = data;
        },
        getSESTemplate() {
            this.fields.templateSES= {
                HtmlPart: this.htmltemplate,
                TextPart: this.texttemplate
            };
        },
        prepareFields(nowizard) {
            let validation = true;
            let notificationText = [];
        
            if(!this.fields.templateUnlayer || !this.fields.templateSES) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.notCreated'));
            }
            if(!this.unsubscribe) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.unsubscribe'));
            }
            if(!this.valid) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.macros'));
            }

            if(this.item.scheduleType == 'BACK_TO_CART' && this.fields.templateSpecs.recommendationsCount > 1) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.btcRec'));
            }

            if(!this.fields.subject || this.fields.subject.trim().length == 0) {
                validation = false;
                notificationText.push(this.$t('campaigns.design.errors.subject'));
            }

            // if user requests next wizard step, but has no campaign active and is not making the current campaign active
            if(!nowizard && !(this.campaign?.variants.some(v => v.active) || this.fields.active)) {
                notificationText.push(this.$t('campaigns.design.errors.noActiveVariant'));
                validation = false;
            }

            if(!validation) {
                this.$store.dispatch('ui/notify', { error: true, text: this.$t('form.errors.fix', { errors: notificationText.join(' ')}) })
            }
            
            return validation;
        },

        afterSave() {
            // reload the list of variants
            this.$store.dispatch('campaigns/get', {id: this.campaign.id});
        },

        autosave() {
            if(this.item && this.detectChange(this.fields.templateUnlayer, this.item.templateUnlayer)) {
                // There should be no problem with concurrency as the templateUnlayer versions should be the same
                //console.debug('Autosaving...');
                this.$store.dispatch('variants/updateFields', { fields: { templateUnlayer: this.fields.templateUnlayer, subject: this.fields.subject }}).then(()=> {
                    this.$store.dispatch('ui/notify', { text: this.$t('campaigns.design.save.success'), timeout: 1000});
                }).catch(()=> { this.$store.dispatch('ui/notify', { text: this.$t('campaigns.design.save.error'), timeout: 5000 }) });
            }
        },
        detectCampaignVariants() {
            if(this.campaign && !(this.campaign.variants?.length > 0)) {
                //console.log('I want to route to legacy', this.item);
                this.force = true;
                this.$router.push({ name: 'campaign-design-email-legacy'});
            }
            if(!this.$route.params.variant && this.campaign) {
                // forces route navigation - consumed by confirm-leave mixin
                this.force = true;
                this.$router.push({ name: 'campaign-design-email-variant', params: { variant: this.campaign.variants[0].id }});
            }
        },
        async addVariant() {
            this.creating = true;
            // campaign and domain will eventually load
            // do not translate, nobody will see this
            if(!this.campaign || !this.domain) {
                this.$store.dispatch('ui/notify', { text: 'Not fully loaded', timeout: 1000});
                return;
            } 
            await this.$store.dispatch('variants/create', { campaign: this.campaign, domain: this.domain });
            await this.$store.dispatch('campaigns/get', { id: this.campaign.id });
            this.creating = false;
            this.$router.push({ name: 'campaign-design-email-variant', params: { variant: this.campaign.variants[this.campaign.variants.length - 1].id }});
        }

    },
    created() {
        this.detectCampaignVariants();
        this.$store.commit('ui/wizard', {value: true });
        this.setLastEditableStep();
        this.loadCategories();
    },
    timers: {
        autosave: { time: 60000, autostart: true, repeat: true }
    }
}
</script>